import React from 'react';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';
import { FormattedDate, FormattedTime } from 'react-intl';

const TimeSlider = props => {
  const { value, minValue, maxValue } = props;
  return (
    <div>
      <div className="time-slider-time-date-info row">
        <div className="col-xs-5 col-xs-offset-3 col-sm-3 col-sm-offset-5">
          <h1>
            <FormattedTime
              value={new Date(value.min)}
              timeZone="UTC"
              hour="2-digit"
              minute="2-digit"
            />
          </h1>
          <h3>
            <FormattedDate
              value={new Date(value.min)}
              day="numeric"
              month="numeric"
            />
          </h3>
        </div>
        <div className="col-xs-5 col-sm-3">
          <h1>
            <FormattedTime
              value={new Date(value.max)}
              timeZone="UTC"
              hour="2-digit"
              minute="2-digit"
            />
          </h1>
          <h3>
            <FormattedDate
              value={new Date(value.max)}
              day="numeric"
              month="numeric"
            />
          </h3>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-xs-12 col-xs-offset-2 col-sm-10 col-sm-offset-3">
            <InputRange {...props} formatLabel={() => null} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-7 col-xs-offset-1 col-sm-6 col-sm-offset-2 start-xs">
            <p>
              <FormattedTime
                value={new Date(minValue)}
                timeZone="UTC"
                hour="2-digit"
                minute="2-digit"
              />
              <br />
              <FormattedDate
                value={new Date(minValue)}
                day="numeric"
                month="numeric"
              />
            </p>
          </div>
          <div className="col-xs-7 col-sm-6 end-xs">
            <p>
              <FormattedTime
                value={new Date(maxValue)}
                timeZone="UTC"
                hour="2-digit"
                minute="2-digit"
              />
              <br />
              <FormattedDate
                value={new Date(maxValue)}
                day="numeric"
                month="numeric"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
//
// const getTimeRangeMarkDescription = () => {
//   return null;
// };

TimeSlider.propTypes = {
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  value: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
};

export default TimeSlider;
